type InterpolationParams = { [key: string]: string | number };

export function interpolate(template: string, params: InterpolationParams): string {
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    return params[key] !== undefined ? params[key].toString() : "";
  });
}
